<template lang="pug">
  #app
    header-component
      media-component
    main-component
      router-view
    footer-component
</template>

<script>
import {HeaderComponent, MainComponent, FooterComponent, MediaComponent} from '@/components'
export default {
  components: { HeaderComponent, MainComponent, FooterComponent, MediaComponent },
  name: 'App',
  mounted () {
    this.$eventbus.$on('set-locale', (newLocale) => {
      this.$i18n.locale = newLocale
      window.localStorage.lang = newLocale
      this.$el.setAttribute('lang', newLocale)
    })
  }
}
</script>

<style lang="stylus">
@import 'css/app'

#header
  position fixed
  top 0
  z-index 999

</style>



// WEBPACK FOOTER //
// src/App.vue